import actions from '@/core/store/item-aditivo-apostila/actions'
import mutations from '@/core/store/item-aditivo-apostila/mutations'
import state from '@/core/store/item-aditivo-apostila/state'

export default {
	actions,
	mutations,
	state,
}
